import { render, staticRenderFns } from "./MyChangeKennelOwnerRequest.vue?vue&type=template&id=42b97e2f"
import script from "./MyChangeKennelOwnerRequest.vue?vue&type=script&lang=ts"
export * from "./MyChangeKennelOwnerRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports